import { unwrapApiResponse } from "./unwrapApiResponse";

/**
 * Reads a POST /codifyv3 response: { ok, codified (pretty JSON string or ""),
 * message (the API's error or result message), status }. The body is in the
 * standard envelope ({ response: { data } } or { error: { message } }).
 */
export const readCodifyResponse = async (res) => {
  const text = await res.text();
  let body;
  try { body = JSON.parse(text); } catch { body = {}; }
  let data = null;
  let message = body?.error?.message || null;
  if (res.ok) {
    try {
      data = unwrapApiResponse(body);
    } catch (err) {
      message = err.message;
    }
  }
  const raw = data?.codifiedJSON;
  let codified = "";
  if (raw) {
    if (typeof raw === "string") {
      try { codified = JSON.stringify(JSON.parse(raw), null, 2); }
      catch { codified = raw; }
    } else {
      codified = JSON.stringify(raw, null, 2);
    }
  }
  return {
    ok: res.ok && !message,
    codified,
    message: message || data?.message || (res.ok ? null : `Codification failed (${res.status})`),
    status: res.status,
  };
};
